import { motion } from "framer-motion";
import { Star, Quote, MapPin } from "lucide-react";
import SectionHeading from "@/components/SectionHeading";
import { REVIEWS } from "@/constants/site";

export default function Reviews() {
  return (
    <section id="reviews" className="grain relative bg-navy py-20 sm:py-28" data-testid="reviews-section">
      <div className="relative mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-12">
          <div className="lg:col-span-4">
            <SectionHeading
              number="03"
              caption="Proof, Not Promises"
              title="GTA Homeowners Talk."
              dark
            />
            <motion.div
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.7 }}
              className="-mt-6"
              data-testid="reviews-summary"
            >
              <p className="font-display text-7xl font-black text-white sm:text-8xl">4.9</p>
              <div className="mt-2 flex text-amber-400">
                {[...Array(5)].map((_, i) => (
                  <Star key={i} className="h-6 w-6 fill-current" />
                ))}
              </div>
              <p className="mt-3 text-sm text-slate-300">
                Based on 1,480+ repair appointments across Toronto & the GTA.
              </p>
            </motion.div>
          </div>

          <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:col-span-8">
            {REVIEWS.map((review, i) => (
              <motion.figure
                key={review.author}
                data-testid={`review-card-${i}`}
                initial={{ opacity: 0, y: 32 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 0.6, delay: i * 0.1, ease: [0.16, 1, 0.3, 1] }}
                className="flex flex-col rounded-2xl border border-white/10 bg-white/5 p-6 backdrop-blur-sm transition-colors duration-300 hover:border-red-400/40 hover:bg-white/10"
              >
                <Quote className="h-6 w-6 text-rescue" />
                <blockquote className="mt-4 flex-1 text-sm leading-relaxed text-slate-200">
                  "{review.comment}"
                </blockquote>
                <figcaption className="mt-5 border-t border-white/10 pt-4">
                  <div className="flex items-center justify-between gap-3">
                    <div>
                      <p className="text-sm font-bold text-white">{review.author}</p>
                      <p className="mt-0.5 flex items-center gap-1 text-xs text-slate-400">
                        <MapPin className="h-3 w-3" /> {review.location}
                      </p>
                    </div>
                    <div className="text-right">
                      <div className="flex text-amber-400">
                        {[...Array(5)].map((_, s) => (
                          <Star key={s} className="h-3.5 w-3.5 fill-current" />
                        ))}
                      </div>
                      <p className="mt-1 font-mono text-[10px] uppercase tracking-wider text-slate-400">
                        {review.appliance} • {review.date}
                      </p>
                    </div>
                  </div>
                </figcaption>
              </motion.figure>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
